// extracted by mini-css-extract-plugin
module.exports = {"item":"customersListItemSkeleton_item__2oJTp","row":"customersListItemSkeleton_row__2LUXE"};